import moment from 'moment'
import React, {createContext, useContext, useState, ReactNode} from 'react'

interface SelectedYearContextType {
  selectedYear: string
  setSelectedYear: (year: string) => void
}

const SelectedYearContext = createContext<SelectedYearContextType | undefined>(undefined)

export const SelectedYearProvider: React.FC<{children: ReactNode}> = ({children}) => {
  const currentYear = moment().format('YYYY')
  const [selectedYear, setSelectedYear] = useState(currentYear)

  return (
    <SelectedYearContext.Provider value={{selectedYear, setSelectedYear}}>
      {children}
    </SelectedYearContext.Provider>
  )
}

export const useSelectedYear = () => {
  const context = useContext(SelectedYearContext)
  if (!context) {
    throw new Error('useSelectedYear must be used within a SelectedYearProvider')
  }
  return context
}
